var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("WrapperDocRef", {
        attrs: { title: _vm.$t("message.refdocs") },
        scopedSlots: _vm._u(
          [
            _vm.sale.status == "approved"
              ? {
                  key: "content",
                  fn: function() {
                    return [
                      _c("BaseSectionDocRefLink", {
                        attrs: {
                          title:
                            _vm.$t("sidebar.invoice") +
                            " (" +
                            _vm.sale.reference.invoices.length +
                            ")",
                          links: _vm.INVLinks,
                          createButtonText: _vm.$t("newdocuments.in"),
                          showCreateButton: !_vm.disabled
                        },
                        on: { onCreate: _vm.handleClickCreateINV }
                      }),
                      _vm._v(" "),
                      _c("BaseSectionDocRefLink", {
                        attrs: {
                          title:
                            _vm.$t("sidebar.goodsissue") +
                            " (" +
                            _vm.sale.reference.goodsissues.length +
                            ")",
                          links: _vm.GILinks,
                          createButtonText: _vm.$t("newdocuments.gi"),
                          showCreateButton:
                            _vm.filterOrdersCanBeIssueCount > 0 && !_vm.disabled
                        },
                        on: { onCreate: _vm.handleClickCreateGI }
                      })
                    ]
                  },
                  proxy: true
                }
              : {
                  key: "content",
                  fn: function() {
                    return [_vm._v("\n      -\n    ")]
                  },
                  proxy: true
                }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "invoiceModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "col row no-padding no-margin" }, [
                    _c("div", { staticClass: "col-6 no-padding" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("sidebar.invoice")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 no-padding text-right" },
                      [
                        [
                          !_vm.nextInCode
                            ? _c("h5", { staticClass: "modal-title" }, [
                                _c("i", {
                                  staticClass: "fas fa-spinner spin",
                                  staticStyle: {
                                    "font-size": "15px",
                                    position: "relative",
                                    top: "-1px"
                                  }
                                })
                              ])
                            : _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.nextInCode) +
                                    "\n                "
                                )
                              ])
                        ]
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    [
                      _vm.formIN_isReady
                        ? _c("form-invoice", {
                            attrs: {
                              so: _vm.sale,
                              validation: _vm.trickValidationIN
                            },
                            on: { submit: _vm.onSubmitInvoice }
                          })
                        : _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.loading")) +
                                "\n            "
                            )
                          ])
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading || !_vm.nextInCode
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeInvoiceModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: {
                            disabled: !_vm.formIN_isReady,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.trickValidationIN++
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.save")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading && _vm.nextInCode
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "goodsissueModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "col row no-padding no-margin" }, [
                    _c("div", { staticClass: "col-6 no-padding" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("sidebar.goodsissue")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 no-padding text-right" },
                      [
                        [
                          !_vm.nextGiCode
                            ? _c("h5", { staticClass: "modal-title" }, [
                                _c("i", {
                                  staticClass: "fas fa-spinner spin",
                                  staticStyle: {
                                    "font-size": "15px",
                                    position: "relative",
                                    top: "-1px"
                                  }
                                })
                              ])
                            : _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.nextGiCode) +
                                    "\n                "
                                )
                              ])
                        ]
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    [
                      _vm.formGI_isReady
                        ? _c("form-goodsissue", {
                            attrs: {
                              so: _vm.sale,
                              validation: _vm.trickValidationGI
                            },
                            on: { submit: _vm.onSubmitGoodsIssue }
                          })
                        : _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.loading")) +
                                "\n            "
                            )
                          ])
                    ]
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading || !_vm.nextGiCode
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeGoodsIssueModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: {
                            disabled: !_vm.formGI_isReady,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              _vm.trickValidationGI++
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.save")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading && _vm.nextGiCode
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(1)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456de5f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456de5f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/sales/so/include/RefSO.vue
// module id = null
// module chunks = 